import React from "react";
import ModalFormCaja from "./ModalFormCaja";

const ModalCaja = ({ show, handleClose, caja }) => {
  return (
    <ModalFormCaja show={show} handleClose={handleClose} caja={caja} />
  );
};

export default ModalCaja;
